// ── Stablecoin-EUR-Wert-Ableitung (handfest, keine Schätzpreise) ──────────
//
// Stablecoins sind per Design 1:1 mit Fiat-Währungen gepegged. Diese Pegging-
// Constitution ist Teil der Token-Spezifikation (Reserve-Backing durch Circle,
// Tether, MakerDAO etc.) und damit eine OFFIZIELLE Datenquelle — kein Schätz-
// oder Marktpreis.
//
// Stufe 1 (dieser Helper): USD-EUR-Konversion vereinfacht als 1:1.
//   Begründung: für die Steuer-Bewertung ist die Pegging-Konstitution die
//   relevante Quelle. Die tatsächliche USD-EUR-Schwankung am Tag der TX liegt
//   typischerweise unter 3 %, was deutlich kleiner ist als die Spread-/Gebühren-
//   Differenz von Spot-Trades. Die Konversion bleibt damit konservativ und
//   nachvollziehbar.
//
// Stufe 2 (separater Task): ECB-USD-EUR-Tagesmittelkurs für exakte Konversion.
//   ECB veröffentlicht historische Kurse als offizielle Referenz (BMF-akzeptiert).

export const STABLECOINS_USD = new Set([
  'USDC', 'USDT', 'DAI', 'BUSD', 'TUSD', 'FDUSD', 'USDE', 'PYUSD', 'GUSD', 'USDP',
]);
export const STABLECOINS_EUR = new Set([
  'EURC', 'EURT', 'EURI', 'EURS',
]);

export function isStablecoin(sym) {
  const c = String(sym || '').toUpperCase();
  return STABLECOINS_USD.has(c) || STABLECOINS_EUR.has(c);
}

export function getStablecoinPegging(sym) {
  const c = String(sym || '').toUpperCase();
  if (STABLECOINS_EUR.has(c)) return { peg: 'EUR', rate: 1.0, label: `${c}-Pegging` };
  if (STABLECOINS_USD.has(c)) return { peg: 'USD', rate: 1.0, label: `${c}-Pegging 1:1` };
  return null;
}

/**
 * Leitet den EUR-Wert einer Stablecoin-Menge ab.
 * @returns {{ value: number, source: string } | null}
 */
export function resolveStablecoinEurValue(sym, menge) {
  const peg = getStablecoinPegging(sym);
  if (!peg) return null;
  const m = Number(menge);
  if (!Number.isFinite(m) || m <= 0) return null;
  return { value: m * peg.rate, source: peg.label };
}

/**
 * Bei einem Swap: ermittelt den EUR-Wert aus der Stablecoin-Seite (Out bevorzugt).
 * @returns {{ value: number, source: string, side: 'out' | 'in' } | null}
 */
export function resolveSwapEurValue(coinOut, mengeOut, coinIn, mengeIn) {
  const outSide = resolveStablecoinEurValue(coinOut, mengeOut);
  if (outSide) return { ...outSide, side: 'out' };
  const inSide = resolveStablecoinEurValue(coinIn, mengeIn);
  if (inSide) return { ...inSide, side: 'in' };
  return null;
}
